import { Button } from "@omony/ui";
import { ChevronDown, ChevronUp, Scale } from "lucide-react";
import { useState } from "react";
import { useT } from "./common.js";
import type { StepId } from "./FlowStepper.js";
import styles from "./flow.module.css";

/** Rechtsrahmen (A05): die Regeln des Prototyps, je Schritt hervorgehoben. Standardmäßig eingeklappt. */
const GUARDS: Array<{ id: string; steps: StepId[] }> = [
  { id: "vereinbarung", steps: ["patient", "bestaetigen"] },
  { id: "zertifizierung", steps: ["video"] },
  { id: "lenkung", steps: ["sprache", "video", "ergebnis"] },
  { id: "gebuehr", steps: ["abrechnung"] },
  { id: "rollen", steps: ["sprache", "ersteinschaetzung", "warten", "video", "ergebnis", "abrechnung"] },
  { id: "durchleitung", steps: ["warten", "video"] },
];

export function LegalPanel({ step }: { step: StepId }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  return (
    <aside className={styles.legal} aria-label={t("console.legal.title")}>
      <Button
        variant="secondary"
        className={styles.legalToggle}
        icon={<Scale />}
        aria-expanded={open}
        aria-controls="legal-list"
        onPress={() => setOpen((o) => !o)}
      >
        {t("console.legal.title")}
        {open ? <ChevronUp aria-hidden="true" size={16} /> : <ChevronDown aria-hidden="true" size={16} />}
      </Button>
      {open ? (
        <>
          <ul id="legal-list" className={styles.legalList}>
            {GUARDS.map((g) => {
              const active = g.steps.includes(step);
              return (
                <li key={g.id} className={styles.legalItem} data-active={active}>
                  <p className={styles.legalLaw}>{t(`console.legal.${g.id}.law`)}</p>
                  <p className={styles.legalDesc}>{t(`console.legal.${g.id}.desc`)}</p>
                </li>
              );
            })}
          </ul>
          <p className={styles.legalFoot}>{t("console.legal.foot")}</p>
        </>
      ) : null}
    </aside>
  );
}
